"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
require("core-js");
var moment = require("moment");
var React = require("react");
var react_dates_1 = require("react-dates");
var Cooltip_1 = require("../Cooltip");
var DateRangePicker = (function (_super) {
    __extends(DateRangePicker, _super);
    function DateRangePicker(props) {
        var _this = _super.call(this, props) || this;
        moment.locale(_this.getLocale());
        _this.state = {
            focusedInput: null,
        };
        _this.onFocusChange = _this.onFocusChange.bind(_this);
        return _this;
    }
    DateRangePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, errorMessage = _a.errorMessage, isOutsideRange = _a.isOutsideRange, validationState = _a.validationState, rest = __rest(_a, ["errorMessage", "isOutsideRange", "validationState"]);
        var rangeFunc = isOutsideRange;
        if (!isOutsideRange) {
            rangeFunc = function () { return false; };
        }
        var validationClass = '';
        if (validationState === 'invalid') {
            validationClass = 'invalid';
        }
        else if (validationState === 'valid') {
            validationClass = 'valid';
        }
        var datePickerClassNames = classNames({}, validationClass);
        var highlightTodayFunc = function (day) { return react_dates_1.isSameDay(day, moment()); };
        var initialMonth = function () { return _this.props.startDate || _this.props.endDate || moment(); };
        var dateRangePicker = (React.createElement("div", { className: datePickerClassNames },
            React.createElement(react_dates_1.DateRangePicker, { startDate: this.props.startDate, endDate: this.props.endDate, focusedInput: this.state.focusedInput, disabled: this.props.disabled, onDatesChange: this.props.onDatesChange, startDateId: this.props.startDateId, endDateId: this.props.endDateId, onFocusChange: this.onFocusChange, startDatePlaceholderText: this.props.startDatePlaceholder || 'From', endDatePlaceholderText: this.props.endDatePlaceholder || 'To', isDayHighlighted: highlightTodayFunc, initialVisibleMonth: initialMonth })));
        if (this.props.validationState === 'invalid'
            && this.props.errorMessage
            && this.props.errorMessage !== ''
            && !this.state.focusedInput) {
            return React.createElement(Cooltip_1.Cooltip, { tooltipType: 'error', tooltipContents: React.createElement("span", null, this.props.errorMessage), placement: 'bottom' }, dateRangePicker);
        }
        else {
            return dateRangePicker;
        }
    };
    DateRangePicker.prototype.onFocusChange = function (arg) {
        this.setState({
            focusedInput: arg
        });
    };
    DateRangePicker.prototype.getLocale = function () {
        // tslint:disable-next-line:no-string-literal
        return navigator['languages'] ? navigator['languages'][0] : (navigator.language || navigator['userLanguage']);
    };
    return DateRangePicker;
}(React.Component));
exports.DateRangePicker = DateRangePicker;
//# sourceMappingURL=DateRangePicker.js.map